import IconButton from "./IconButton";
import SvgMapper from "./SvgMapper";

const InfoHeader = ({
  title,
  subtitle,
  status,
  score,
  onClose,
  onAction,
  actionLabel = "Action",
  actionIcon = "download",
}) => {
  return (
    <>
      <div className="flex items-center space-x-4">
        {onClose && (
          <button
            className="p-2 text-gray-400 hover:text-gray-600 rounded-lg hover:bg-gray-100"
            onClick={onClose}
          >
            {SvgMapper.close("w-5 h-5")}
          </button>
        )}
        <div>
          {title && <h1 className="text-2xl font-bold text-gray-900">{title}</h1>}
          {subtitle && <p className="text-gray-600">{subtitle}</p>}
        </div>
      </div>
      <div className="flex items-center space-x-3">
        {status && (
          <span
            className={`px-3 py-1 rounded-full text-sm font-medium ${
              status.toLowerCase() === "completed"
                ? "text-green-600 bg-green-50"
                : "text-gray-600 bg-gray-100"
            }`}
          >
            {status}
          </span>
        )}
        {score !== undefined && (
          <div className="flex items-center space-x-2 bg-gray-100 rounded-lg px-3 py-2">
            {SvgMapper.award("w-4 h-4 text-gray-600")}
            <span className="font-semibold text-gray-900">{score}%</span>
          </div>
        )}

         {onAction && (
          <IconButton
            label={actionLabel}
            icon={actionIcon}
            onClick={onAction}
            color="blue-600"
            hoverColor="blue-700"
          />
        )}
      </div>
    </>
  );
};

export default InfoHeader;
